export enum TagInputTypes {
    TO = 'to',
    FROM = 'from',
    CC = 'cc',
    EMAIL = 'email',
    DOMAIN = 'domain',
    SENDER_DOMAIN = 'sender_domain',
    DNS = 'dns',
    URL = 'url',
    IP = 'ip',
    FILEHASH = 'file_hash',
}

export interface TagInputProps {
    tags?: string[];
    handleModifyTags?: (type: string, tags: string[]) => void;
    tagRef?: any;
    handleChange?:any;
    type?: TagInputTypes | '' | any;
    paramSendMail?:any;
    setParamSendMail?:any;
    checkboxInput?:any;
    validateToField?: boolean;
    setValidateToField?: (value: boolean) => void,
    disabled?: boolean;
    focusHandler?: (event: any) => void;
    changeHandler?: (type: string, event: any) => void;
    placeholder?: string;
    errorMsg?: string;
    error?: boolean;
    setError?: (value: boolean) => void;
    inputRows?: number;
    maxTags?: number;
    maxInputLength?: number;
    inputValue?: string;
    setInputValue?: (value: string) => void;
}
